<script setup lang="ts">
import vuIcon from '@ds/vuekit/src/components/vu-icon.vue';

const props = defineProps({
  isDirectPurchase: {
    type: Boolean,
    default: false,
  },
  flat: {
    type: Boolean,
    default: false,
  },
});
</script>
<template>
  <div :class="['lab-card-skeleton shimmer', { flat: props.flat }]">
    <div class="icon-container loading-gray-circle" style="width: 44px; height: 44px" />
    <div class="info-container">
      <div class="flex align-items-centers justify-space-between">
        <!-- Lab Card Title -->
        <div class="loading-gray-box" style="width: 150px; height: 17px; margin-bottom: 6px" />
        <!-- Price -->
        <div
          v-if="props.isDirectPurchase"
          class="loading-gray-box"
          style="width: 25px; height: 15px"
        />
      </div>
      <div class="flex">
        <div class="spec-column">
          <div class="spec">
            <vu-icon icon="location" style="margin-right: 5px; margin-left: 0" />
            <div style="width: 70px; height: 17px" class="loading-gray-box" />
            <!-- Country -->
          </div>
          <div class="loading-gray-box" style="width: 100px; height: 17px" />
          <!-- More info -->
        </div>
        <div v-if="props.isDirectPurchase" class="spec-column buy-button">
          <div class="flex">
            <vu-icon icon="clock" />
            <div
              style="margin-left: 5px; width: 35px; height: 17px; margin-right: 2px"
              class="loading-gray-box"
            />
            <!-- Worth tat / Lead Time -->
          </div>
          <div style="width: 77px; height: 39px" class="loading-gray-box" />
          <!-- Buy button -->
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
@use '/assets/scss/variables' as variables;
@forward '/assets/scss/skeletons';

.lab-card-skeleton {
  overflow: hidden;
  display: flex;
  background-color: white;
  padding: 10px;
  position: relative;
  width: 100%;
  border-radius: 5px;
  border: solid 1px #d1d4d4;

  &.flat {
    border: none;
    border-bottom: solid 1px #d1d4d4;
    border-radius: 0px;
  }

  .icon-container {
    min-width: 44px;
    width: 44px;
    height: 44px;
    line-height: 44px;
  }

  .info-container {
    margin-left: 8px;
    flex-grow: 1;
    overflow: hidden;

    .spec-column {
      flex-grow: 1;
      margin-top: 2px;
      max-width: 50%;

      .spec {
        display: flex;
        justify-content: flex-start;
        flex-wrap: nowrap;
        margin-bottom: 5px;
      }
    }

    .buy-button {
      display: flex;
      justify-content: space-between;
    }
  }
}

@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}

.loading-gray-circle {
  background: gainsboro;
  border-radius: 50%;
}

.loading-gray-box {
  background: gainsboro;
  border-radius: 7px;
}

.loading-gray-box.no-radius {
  border-radius: unset;
}
</style>
